<script>
import appConfig from "@/app.config";
import { required, minLength } from "vuelidate/lib/validators";
/**
 * Recover password Sample page
 */
export default {
    data() {
        return {
            submitted: false,
            password: "",
            password_confirmation: "",
            buttonName: "Reset",
            isAuthError: false,
            authError: "",
            token: null,
            userId: null 
        };
    },
    validations: {
        password: {
            required, minLength: minLength(6)
        },
        password_confirmation: {
            required, minLength: minLength(6)
        },
    },
    mounted() {
        let url = new URLSearchParams(window.location.search);
        if (url.has("userId") && url.has("token")) {
            this.userId = url.get("userId");
            this.token = url.get("token");
        } else {
            this.$router.replace("/login");
        }
    },
    methods: {
        tryToResetpwd() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                this.buttonName = "Resetting";
                this.$store
                    .dispatch("account/VerifyForgotPassword", {
                        token: this.token,
                        userId: this.userId,
                        newPassword: this.password,
                    })
                    .then((res) => {
                        if (res.data.error) {
                            this.isAuthError = true;
                            this.authError = res.data.errorMessage;
                            this.buttonName = "Reset";
                        } else {
                            this.showToast(
                                "Password reset successfully. You can login now!",
                                "success"
                            );
                            this.$router.push({ name: "default" });
                        }
                    })
                    .catch((err) => {
                        this.isAuthError = true;
                        this.authError = "Something went wrong";
                        this.buttonName = "Reset";
                    });
            }
        },
    },
    page: {
        title: "Reset password",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
};
</script>

<template>
    <div class="account-pages my-5 pt-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card overflow-hidden">
                        <div class="bg-soft-primary">
                            <div class="row">
                                <div class="col-7">
                                    <div class="text-primary p-4">
                                        <h5 class="text-primary">
                                            Reset Password
                                        </h5>
                                        <p>Reset your password here.</p>
                                    </div>
                                </div>
                                <div class="col-5 align-self-end">
                                    <img
                                        src="@/assets/images/profile-img.png"
                                        alt
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div>
                                <a href="/">
                                    <div
                                        class="avatar-md profile-user-wid mb-4"
                                    >
                                        <span
                                            class="
                                                avatar-title
                                                rounded-circle
                                                bg-light
                                            "
                                        >
                                            <img
                                                src="@/assets/images/logo.svg"
                                                alt
                                                class="rounded-circle"
                                                height="34"
                                            />
                                        </span>
                                    </div>
                                </a>
                            </div>
                            <b-alert :show="isAuthError" variant="danger">
                                <i class="mdi mdi-block-helper me-2"></i
                                >{{ authError }}
                            </b-alert>
                            <div class="p-2">
                                <form
                                    class="form-horizontal"
                                    @submit.prevent="tryToResetpwd"
                                >
                                    <div class="form-group mb-3">
                                        <label for="password"
                                            >New Password</label
                                        >
                                        <input
                                            type="password"
                                            v-model="password"
                                            class="form-control"
                                            id="password"
                                            placeholder="Enter new password"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.password.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                !$v.password.required
                                            "
                                            class="invalid-feedback"
                                        >
                                            Password is required.
                                        </div>
                                        <div v-if="submitted && !$v.password.minLength" class="invalid-feedback">Password should be at least 5 characters. </div>
                                    </div>

                                    <div class="form-group mb-3">
                                        <label for="confirm_pwd"
                                            >Confirm Password</label
                                        >
                                        <input
                                            v-model="password_confirmation"
                                            type="password"
                                            class="form-control"
                                            id="confirm_pwd"
                                            placeholder="Enter confirm password"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.password_confirmation
                                                        .$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                !$v.password_confirmation
                                                    .required
                                            "
                                            class="invalid-feedback"
                                        >
                                            Confirm Password is required.
                                        </div>
                                        <div v-if="submitted && !$v.password_confirmation.minLength" class="invalid-feedback">Confirm Password should be at least 5 characters. </div>
                                    </div>

                                    <div class="form-group row mb-0">
                                        <div class="col-12 text-end">
                                            <button
                                                class="btn btn-primary w-md"
                                                type="submit"
                                            >
                                                {{ buttonName }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
